import React from 'react';
import { Heart, Award, Trophy, Star, Users, Target } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CommunityPage = () => {
  const sponsorships = [
    {
      name: "Macgregor Cricket Club",
      logo: "https://res.cloudinary.com/playhq/image/upload/h_128,w_128/v1/production/ca/22063b4a-44d5-4c3b-918f-2fd0a2fe4962/1702975823967/logo.jpg?_a=BAMAMifg0",
      link: "https://macgregorcc.org.au/"
    },
    {
      name: "Brisbane Stallions",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxPx-OkFwBLk8MQkhtTLxNMp_8l0YKkwjRbQ&s",
      link: "https://brisbanestallions.com.au/"
    },
    {
      name: "Global Organisation of People of Indian Origin",
      logo: "https://indiacurrents.com/wp-content/uploads/2024/04/gopio.png",
      link: "https://www.gopio.net/"
    },
    {
      name: "GOPIO Cairns",
      logo: "https://static.wixstatic.com/media/0b58b3_a910f53a2d164b8e91febc8ba4b7234a~mv2.png/v1/fit/w_2500,h_1330,al_c/0b58b3_a910f53a2d164b8e91febc8ba4b7234a~mv2.png",
      link: "https://www.gopiocairns.org.au/"
    },
    {
      name: "Himalayan Organisation For Multiculatural Communities",
      logo: "https://scontent.fbne3-1.fna.fbcdn.net/v/t39.30808-1/605531040_122104113255184214_760407389450450000_n.jpg?stp=dst-jpg_tt6&cstp=mx1024x1024&ctp=s200x200&_nc_cat=110&ccb=1-7&_nc_sid=2d3e12&_nc_ohc=KXj51bsQnLgQ7kNvwEpDeTd&_nc_oc=AdqsyCgIe92lU5fXVFKfpeKGl2ePQ0_OUylHkBla9jBoXWioN2gmsYWj18IKLvPCc48&_nc_zt=24&_nc_ht=scontent.fbne3-1.fna&_nc_gid=Otj0nbL9Agv9BDncp_iY5A&_nc_ss=7a289&oh=00_AQI32jQCE5iTc2IBDT2wb2TB1I80l_7aQiCr6cucf8vLSw&oe=6A9AE72D",
      link: "https://www.facebook.com/people/Himalayan-Organisation-for-Multicultural-Communities-Inc-HOMC/61585526442535/#"
    }
  ];

  const achievements = [
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/FBAA%20Approved%20Mentor%20Seal.png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25",
      name: "FBAA-Certified Mentor"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/We%20Mentor%20You%20(4).png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25",
      name: "My Local Broker 2021 Top 10 Brokers"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/image.png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25",
      name: "Bankwest 2023 Broker of the Year - Finalist - Victoria"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/QLD%20Broker_Finalist.png/:/",
      name: "My Local Broker 2024 Brokerage of the Year - Finalist - Queensland"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/shared%20image.jpg/:/",
      name: "Bankwest 2025 Broker of the Year for Customer Experience - Finalist - Victoria"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/2.png/:/",
      name: "Gold Coast Girls in Business Awards 2025 Winner"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/1-34bd1a0.png/:/cr=t:0%25,l:0%25,w:100%25,h:100%25",
      name: "Gold Coast Girls in Business Awards 2025 Finalist"
    },
    {
      award: "MLB_Top_10_Broker_2025.png",
      name: "My Local Broker 2025 Top 10 Brokers"    
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/winner.png/:/",
      name: "Specialist Finance Group 2025 High Achiever - Queensland"
    },
    {
      award: "https://img1.wsimg.com/isteam/ip/c3b8fe5c-1af2-4560-bb9f-50b6450b0d49/winner.png/:/",
      name: "Specialist Finance Group 2026 High Achiever - Queensland"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6" style={{ color: 'rgb(8, 120, 191)' }}>
              Community & Achievements
            </h1>
            <p className="text-xl text-gray-600">
            </p>
          </div>
        </div>
      </section>

      {/* Community Sponsorship Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <Heart className="h-12 w-12 mx-auto mb-4" style={{ color: 'rgb(8, 120, 191)' }} />
              <h2 className="text-4xl font-bold mb-4" style={{ color: 'rgb(8, 120, 191)' }}>
                Community Sponsorship
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {sponsorships.map((sponsor, index) => (
                <a href={sponsor.link} target="_blank" rel="noopener noreferrer">
                  <Card key={index} className="border-2 hover:shadow-lg transition-shadow">
                    <CardHeader className="text-center">
                      <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden bg-gray-100">
                        <img 
                          src={sponsor.logo} 
                          alt={sponsor.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <CardTitle style={{ color: 'rgb(8, 120, 191)' }}>{sponsor.name}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="text-gray-600 text-center">
                        {sponsor.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <Heart className="h-12 w-12 mx-auto mb-4" style={{ color: 'rgb(8, 120, 191)' }} />
              <h2 className="text-4xl font-bold mb-4" style={{ color: 'rgb(8, 120, 191)' }}>
                Achievements
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {achievements.map((award, index) => (
                <Card key={index} className="border-2 hover:shadow-lg transition-shadow">
                  <CardHeader className="text-center">
                    <div className="w-48 h-48 mx-auto mb-4 overflow-hidden bg-gray-100">
                      <img 
                        src={award.award} 
                        alt={award.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <CardTitle style={{ color: 'rgb(8, 120, 191)' }}>{award.name}</CardTitle>
                  </CardHeader>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-[#1392D1] to-[#088CC7]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Partner With an Award-Winning Team
          </h2>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
            Experience the difference of working with a team that's recognised for excellence 
            and committed to giving back to the community.
          </p>
          <a 
            href="/#contact"
            className="inline-block px-8 py-4 bg-white rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            style={{ color: 'rgb(8, 120, 191)' }}
          >
            Get in Touch
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CommunityPage;
